import { mutate } from 'swr'

/**
 * Revalidates multiple SWR cache entries by their URLs
 * @param urls - Array of URLs to revalidate in the SWR cache
 * @returns Promise that resolves when all URLs have been revalidated
 */
const mutateURLs = async (
  urls: (string | null | undefined)[] = []
): Promise<void> => {
  for (const url of urls) {
    if (url) await mutate(url)
  }
}

export default mutateURLs
